// extracted by mini-css-extract-plugin
export default {"container":"footer_container__mwvEI","copyright":"footer_copyright__mILJQ"};